<portal-card class="card--table">
  <h2 header>{{ 'phoneBook.contacts' | portalTranslate }}</h2>

  <ng-container actions>
    <!-- Add new entry -->
    @if (mode !== contactsMode.CALL_CENTER_AGENT) {
      <span>
        <portal-icon-button
          *portalIsAuthorized="{
            anyPermission: [Permission.MANAGE_PHONEBOOK, Permission.MANAGE_ANY_PHONEBOOK],
          }"
          [portalTippy]="'generic.add.entry' | translate"
          (onClick)="add()"
        ></portal-icon-button>
      </span>
    }

    <!-- Refresh -->
    <portal-icon-button
      [loading]="loading"
      [portalTippy]="'generic.reload' | translate"
      (onClick)="refresh()"
      iconClass="far fa-sync"
    ></portal-icon-button>
  </ng-container>

  <portal-loading-indicator-container [loading]="loading">
    <div class="simple-table">
      <table class="table table-hover" portalTable>
        <thead>
          <tr>
            <th>{{ 'phoneBook.name' | portalTranslate }}</th>
            <th>{{ 'phoneBook.numbers' | portalTranslate }}</th>
            <th>{{ 'phoneBook.emails' | portalTranslate }}</th>
            @if (mode !== contactsMode.CALL_CENTER_AGENT) {
              <th class="simple-table__actions"></th>
            }
          </tr>
        </thead>
      </table>
    </div>
  </portal-loading-indicator-container>

  <ng-container *portalTableCell="let entry; data: 'name'">
    @if (canModify(entry)) {
      <button class="btn btn--portal-link d-flex align-items-center text-start" (click)="edit(entry)">
        <ng-container *ngTemplateOutlet="name"></ng-container>
      </button>
    } @else {
      <span>{{ entry.name }}</span>
      @if (entry.vipPriority !== 0) {
        <small>
          <span class="badge text-bg-info">VIP {{ entry.vipPriority }}</span>
        </small>
      }
    }

    <ng-template #name>
      <span>{{ entry.name }}</span>
      @if (entry.vipPriority !== 0) {
        <small>
          <span class="badge text-bg-info">VIP {{ entry.vipPriority }}</span>
        </small>
      }
    </ng-template>

    @if (entry.companyInfo) {
      <div>
        <small [portalTippy]="'phoneBook.contact.companyInfo' | translate">
          <i class="far fa-building text-muted"></i> {{ entry.companyInfo }}
        </small>
      </div>
    }

    @if (entry.groupsInfo) {
      <div>
        <small [portalTippy]="'phoneBook.contact.groups' | translate">
          <span [innerHTML]="entry.groupsInfo"></span>
        </small>
      </div>
    }
  </ng-container>

  <ng-container *portalTableCell="let entry; data: 'businessPhone'">
    <ul class="list-unstyled m-0">
      @if (entry.businessPhone) {
        <li>
          {{ entry.businessPhone }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.work' | portalTranslate }}
          </small>
        </li>
      }
      @if (entry.businessPhone2) {
        <li>
          {{ entry.businessPhone2 }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.work' | portalTranslate }}
          </small>
        </li>
      }
      @if (entry.businessFax) {
        <li>
          {{ entry.businessFax }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.fax' | portalTranslate }}
          </small>
        </li>
      }
      @if (entry.mobilePhone) {
        <li>
          {{ entry.mobilePhone }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.mobile' | portalTranslate }}
          </small>
        </li>
      }
      @if (entry.mobilePhone2) {
        <li>
          {{ entry.mobilePhone2 }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.mobile2' | portalTranslate }}
          </small>
        </li>
      }
      @if (entry.homePhone) {
        <li>
          {{ entry.homePhone }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.home' | portalTranslate }}
          </small>
        </li>
      }
      @if (entry.homePhone2) {
        <li>
          {{ entry.homePhone2 }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.home2' | portalTranslate }}
          </small>
        </li>
      }
      @if (entry.homeFax) {
        <li>
          {{ entry.homeFax }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.fax' | portalTranslate }}
          </small>
        </li>
      }
      @if (entry.extension) {
        <li>
          {{ entry.extension }}
          <small class="ms-1 text-muted">
            {{ 'phoneBook.extension' | portalTranslate }}
          </small>
        </li>
      }
    </ul>
  </ng-container>

  <ng-container *portalTableCell="let entry; data: 'email'">
    <ul class="list-unstyled m-0">
      @if (entry.email) {
        <li>
          <a href="mailto:{{ entry.email }}">{{ entry.email }}</a>
        </li>
      }
      @if (entry.email2) {
        <li>
          <a href="mailto:{{ entry.email2 }}">{{ entry.email2 }}</a>
        </li>
      }
    </ul>
  </ng-container>

  <ng-container *portalTableCell="let entry; id: 'buttons'; class: 'simple-table__actions'">
    @if (canModify(entry)) {
      <div class="btn-group">
        <portal-icon-button
          *portalIsAuthorized="{
            anyPermission: [Permission.MANAGE_PHONEBOOK, Permission.MANAGE_ANY_PHONEBOOK],
          }"
          [portalTippy]="'generic.edit.entry' | translate"
          (onClick)="edit(entry)"
          appendTo="body"
          iconClass="far fa-pencil"
        >
        </portal-icon-button>
        <!-- Delete -->
        <portal-icon-button
          *portalIsAuthorized="{
            anyPermission: [Permission.MANAGE_PHONEBOOK, Permission.MANAGE_ANY_PHONEBOOK],
          }"
          [portalTippy]="'generic.delete.entry' | translate"
          (onClick)="delete(entry)"
          appendTo="body"
          iconClass="far fa-trash"
          variant="danger"
        >
        </portal-icon-button>
      </div>
    }
  </ng-container>
</portal-card>
